/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from "react";
import Styles from "./orderItemCard.module.scss";
import { useTranslation } from "react-i18next";
import UKCounter from "@/common-components-src/components/UKCounter";
import { observer } from "mobx-react-lite";
import { useStores } from "@/app/csr-src/models";
import JDIPrice from "@/common-components-src/js/price/index";
import UKImg from "@/common-components-src/components/UKImg";
import { STOCK_STATUS_CODE, USER_ACTION_ID } from "@/app/csr-src/apis/checkout/constants/constants";
import cn from "clsx";
import ArrowDown from "@/app/csr-src/assets/icons/chevron-down.svg";
import { sendClickTrack } from "@/tracks/25281";

interface orderItemCardProps {
  skuList: any[];
  promiseObj: any;
  addCart: (sku: any[], userActionId: string) => void;
  currentIndex: number;
}

const OrderItemCard = observer((props: orderItemCardProps) => {
  const { t } = useTranslation();
  const [expand, setExpand] = useState(false);
  const { checkoutStore } = useStores();
  const { addCart } = props;
  // 计算sku数量
  const getOrderTotalText = () => {
    // 只有一堆商品时，不展示总数
    if (props.skuList.length <= 1) {
      return "";
    }
    const num = props.skuList.reduce((acc, item) => {
      return acc + Number(item.num);
    }, 0);
    return t("checkout.orderCard.totalItems", { num });
  };

  /** 结算商品楼层数量增加点击 */
  const handleFloorAddTrack = () => {
    const tmp = JSON.parse(JSON.stringify((checkoutStore as any).trackOrderList[props.currentIndex]));
    delete tmp.clickPos;
    delete tmp.is_more;
    sendClickTrack.SettleAccounts_OrderNew_AddItems(tmp)
  }

  /** 结算商品楼层数量减少点击 */
  const handleFloorReduceTrack = (type: string) => {
    sendClickTrack.SettleAccounts_OrderNew_Items({
      ...(checkoutStore as any).trackOrderList[props.currentIndex],
      clickPos: type
    })
  }

  const handleNumChange = (item: any, num: number) => {
    /**
     * 原始商品数量
     */
    const value = Number(item.num);
    if (Number(num) > value) {
      handleFloorAddTrack();
      return
    };
    handleFloorReduceTrack("1");
  }

  return (
    <div className={Styles.orderItemCardBox}>
      <div className={Styles.title}>
        <div className={Styles.promise}>
          {(props.promiseObj.deliveryDate || props.promiseObj.deliveryDateDesc) && (
            <span className={Styles.promiseDate}>
              {props.promiseObj.deliveryDateDesc} {props.promiseObj.deliveryDate}
            </span>
          )}
          {props.promiseObj.promiseLabel}
        </div>
        <div className={Styles.total}>{getOrderTotalText()}</div>
      </div>
      <div className={cn(Styles.orderItemBox, { [Styles.orderItemBoxExpand]: expand })}>
        {props.skuList.map((sku, index) => {
          return (
            <div
              className={cn(Styles.productItem, {
                [Styles.productItemNoStock]: sku.stockStatusCode === STOCK_STATUS_CODE.OUT_STOCK,
              })}
              key={index}
            >
              {/* sku Image */}
              <div className={Styles.imageBox}>
                <UKImg
                  urlExtend={{
                    imgKey: sku.imageUrl,
                    width: 120,
                    height: 120,
                  }}
                />
              </div>
              {/* Product info  */}
              <div className={Styles.basicInfo}>
                {/* Product title  */}
                <div className={Styles.productName}>
                  {/* discount */}
                  {sku.unitPromoDiscount && (
                    <span className={Styles.discountTag}>{sku.unitPromoDiscount}</span>
                  )}
                  {/* skuName */}
                  <span className={Styles.skuName} title={sku.skuName}>
                    {sku.skuName}
                  </span>
                </div>
                {/* product Spec */}
                <div className={Styles.productSpec}>
                  {sku.attrList ? sku.attrList.join(" / ") : null}
                </div>
              </div>
              <div className={Styles.priceBox}>
                {/* price */}
                <JDIPrice
                  symbol={checkoutStore.currencySymbol}
                  price={sku.deliveryPrice}
                  uiType={1}
                  containerStyle={{
                    fontSize: "12px",
                    lineHeight: "16px",
                    color:
                      sku.stockStatusCode === STOCK_STATUS_CODE.OUT_STOCK ? "#888B94" : "inherit",
                  }}
                  integerStyle={{
                    fontSize: "18px",
                    lineHeight: "24px",
                    height: "24px",
                  }}
                />
                {sku.deliveryPrice !== sku.jdPrice && (
                  <div className={Styles.skuPrice}>
                    <JDIPrice
                      symbol={checkoutStore.currencySymbol}
                      price={sku.jdPrice}
                      uiType={2}
                      containerStyle={{
                        fontSize: "12px",
                        lineHeight: "16px",
                        color: "#888B94",
                      }}
                      lineThrough
                    />
                  </div>
                )}
              </div>
              {/* sku quantity */}
              <div className={Styles.quantityBox}>
                {sku.stockStatusCode === STOCK_STATUS_CODE.IN_STOCK ? (
                  <UKCounter
                    immediately={false}
                    value={Number(sku.num)}
                    minAmount={1}
                    maxAmount={200}
                    stock={200}
                    onChange={(num: number) => {
                      addCart([{ ...sku, num: String(num) }], USER_ACTION_ID.CHANGE_NUM);
                      handleNumChange({ ...sku }, num);
                    }}
                    size="small"
                  />
                ) : (
                  <div className={Styles.stockTag}>{t("common.productStatus.outOfStock")}</div>
                )}
              </div>
            </div>
          );
        })}
      </div>
      {!expand && props.skuList.length > 3 && (
        <div className={Styles.viewAll} onClick={() => {
          setExpand(true);
          handleFloorReduceTrack('0');
        }}>
          {t("checkout.orderCard.viewAll")}
          <ArrowDown />
        </div>
      )}
    </div>
  );
});

export default OrderItemCard;
